import { render } from "./AssessmentMark.vue?vue&type=template&id=f53cd90a&scoped=true"
import script from "./AssessmentMark.vue?vue&type=script&lang=js"
export * from "./AssessmentMark.vue?vue&type=script&lang=js"

import "./AssessmentMark.vue?vue&type=style&index=0&id=f53cd90a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f53cd90a"]])

export default __exports__